import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

export enum ScriptId {
  MFE_LOGIN = 'mfe_integration_script',
  SIGN = 'scriptFirma',
  CAU = 'cau_script',
  GTM_SCRIPT = 'gtm_script',
  GTM_IFRAME = 'gtm_iframe'
}

@Injectable({
  providedIn: 'root'
})
export class ScriptsManagerService {
  /**
   * Agrega el script de integracion de login mfe de manera dinamica
   */
  public static AddMfeLoginScript(): void {
    if (!this.IsScriptLoaded(ScriptId.MFE_LOGIN)) {
      const script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.innerHTML = '';
      script.id = ScriptId.MFE_LOGIN;
      script.src = `${environment.integration_url}/mfe_core/js/sslssso.js`;
      document.body.appendChild(script);
    }
  }

  /**
   * Agrega el script de integracion de firma mfe de manera dinamica
   */
  public static AddMfeSignScript() {
    if (!this.IsScriptLoaded(ScriptId.SIGN)) {
      const scriptFirma = document.createElement('script');
      scriptFirma.id = ScriptId.SIGN;
      scriptFirma.src = `${environment.integration_url}/mfe_core/js/mfe_clientSignature.js`;
      document.body.appendChild(scriptFirma);
    }
  }

  private static IsScriptLoaded(scriptId: ScriptId): boolean {
    return !!document.getElementById(scriptId);
  }
}
